// Setul de pictograme al machetei, luat din ea literă cu literă.
//
// Toate desenează pe o grilă 20x20 cu `stroke="currentColor"`, deci culoarea
// vine de la părinte — `.rit`, `.btn`, `.chip` le colorează deja, iar o
// pictogramă nu are nevoie să știe pe ce fundal stă.

type P = { size?: number; className?: string };

function Svg({ size = 18, className, children }: P & { children: React.ReactNode }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none"
         stroke="currentColor" strokeWidth={1.7} strokeLinecap="round"
         strokeLinejoin="round" className={className} aria-hidden="true"
         style={{ flex: "none" }}>
      {children}
    </svg>
  );
}

export const Cauta = (p: P) => (
  <Svg {...p}><circle cx="9" cy="9" r="5.5" /><path d="M17 17l-4-4" /></Svg>
);

export const Fulger = (p: P) => (
  <Svg {...p}><path d="M11 2 4 11.5h5L8 18l7-9.5h-5L11 2z" /></Svg>
);

export const Plus = (p: P) => (
  <Svg {...p}><path d="M10 4v12M4 10h12" /></Svg>
);

export const Urca = (p: P) => (
  <Svg {...p}><path d="M10 13V4M6.5 7.5 10 4l3.5 3.5M4 16h12" /></Svg>
);

export const Sageata = (p: P) => (
  <Svg {...p}><path d="M4 10h12M11 5l5 5-5 5" /></Svg>
);

export const Bifa = (p: P) => (
  <Svg {...p}><path d="M4 10.5l4 4L16.5 6" /></Svg>
);

export const Pin = (p: P) => (
  <Svg {...p}>
    <path d="M10 17.5s-5-4.6-5-8.3A5 5 0 0115 9.2c0 3.7-5 8.3-5 8.3z" />
    <circle cx="10" cy="9" r="1.8" />
  </Svg>
);

export const Folder = (p: P) => (
  <Svg {...p}><path d="M2.5 5h5l1.5 2h8.5v9.5h-15V5z" /></Svg>
);

export const Fisier = (p: P) => (
  <Svg {...p}><path d="M5 2.5h7l3.5 3.5v11.5H5V2.5z" /><path d="M12 2.5V6h3.5" /></Svg>
);

/** Pâlnia de filtrare. Trei linii care se strâng — forma pe care o recunoaște
 *  oricine a mai filtrat un tabel. */
export const Filtru = (p: P) => (
  <Svg {...p}><path d="M3 5h14l-5.2 6.2v4.3l-3.6-1.8v-2.5z" /></Svg>
);

export const X = (p: P) => (
  <Svg {...p}><path d="M5.5 5.5l9 9M14.5 5.5l-9 9" /></Svg>
);

// --- Pictogramele barei laterale ------------------------------------------

export const Acasa = (p: P) => (
  <Svg {...p}><path d="M3.5 9.5 10 4l6.5 5.5" /><path d="M5.5 9.5V16h9V9.5" /></Svg>
);

export const Studio = (p: P) => (
  <Svg {...p}>
    <path d="M10 2.5 16.5 6v8L10 17.5 3.5 14V6L10 2.5z" />
    <path d="M10 10l6.5-4M10 10 3.5 6M10 10v7.5" />
  </Svg>
);

export const Solutii = (p: P) => (
  <Svg {...p}>
    <rect x="3" y="3" width="6" height="6" rx="1.4" />
    <rect x="11" y="3" width="6" height="6" rx="1.4" />
    <rect x="3" y="11" width="6" height="6" rx="1.4" />
    <rect x="11" y="11" width="6" height="6" rx="1.4" />
  </Svg>
);

export const Verificari = Bifa;

export const Costuri = (p: P) => (
  <Svg {...p}><path d="M4 16.5V10M10 16.5V4M16 16.5V8" /></Svg>
);

export const Dosar = Fisier;

export const Preferinte = (p: P) => (
  <Svg {...p}>
    <circle cx="10" cy="10" r="3" />
    <path d="M10 2.5v2.4M10 15.1v2.4M2.5 10h2.4M15.1 10h2.4M4.7 4.7l1.7 1.7M13.6 13.6l1.7 1.7M15.3 4.7l-1.7 1.7M6.4 13.6l-1.7 1.7" />
  </Svg>
);
